import { useParams } from 'react-router';
import { RouteParam } from '../param';
import isNil from '../../helpers/is-nil';

export class UndefinedMandatoryPathParamError extends Error {
  constructor(param: RouteParam) {
    super(`Mandatory path parameter "${param}" is missing.`);
    this.name = 'UndefinedMandatoryPathParamError';
  }
}

export const useMandatoryPathParam = (param: RouteParam): string => {
  const { [param]: value } = useParams();
  if (value === '' || isNil(value)) {
    throw new UndefinedMandatoryPathParamError(param);
  }
  return value;
};
